module.exports = __webpack_public_path__ + "static/media/101-2.4ae474ba.jpg";